// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__OfpCn","emails":"CreateEditClinics_emails__10CMR","emailTagLabel":"CreateEditClinics_emailTagLabel__2drlg"};